import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { sans as zoram, fontSize13, lineHeightTight, fontWeightNormal } from "@churchofjesuschrist/eden-style-constants";
export const internalUseOnlyPriority6 = css(["margin:0;font-family:", ";font-weight:", ";font-size:", ";line-height:", ";"], zoram, fontWeightNormal, fontSize13, lineHeightTight);
const H6Styled = styled.h6.withConfig({
  componentId: "sc-1r3sor6-0"
})(["", ";"], internalUseOnlyPriority6);

const H6 = _ref => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(H6Styled, props, children);
};

export default H6;
H6.propTypes = {
  /** Content inside heading */
  children: PropTypes.node.isRequired
};